module.exports = __webpack_public_path__ + "static/logo-black-ddd2e182f85d56008f0d5833e6815ed0.svg";